/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkturough_Plant_Die_TitleInputs */

const en_walkturough_plant_die_title = /** @type {(inputs: Walkturough_Plant_Die_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you use your phone, your tree will wither.`)
};

const ar_walkturough_plant_die_title = /** @type {(inputs: Walkturough_Plant_Die_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إذا استخدمت هاتفك، ستذبل شجرتك.`)
};

const de_walkturough_plant_die_title = /** @type {(inputs: Walkturough_Plant_Die_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn Sie Ihr Telefon benutzen, wird Ihr Baum verwelken.`)
};

const es_walkturough_plant_die_title = /** @type {(inputs: Walkturough_Plant_Die_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si usas tú teléfono, tú árbol se marchitará`)
};

const fr_walkturough_plant_die_title = /** @type {(inputs: Walkturough_Plant_Die_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si vous utilisez votre téléphone, votre arbre se flétrira.`)
};

const it_walkturough_plant_die_title = /** @type {(inputs: Walkturough_Plant_Die_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se usi il telefono, il tuo albero appassirà.`)
};

const ja_walkturough_plant_die_title = /** @type {(inputs: Walkturough_Plant_Die_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スマホを使うと、木は枯れてしまいます`)
};

const ko_walkturough_plant_die_title = /** @type {(inputs: Walkturough_Plant_Die_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`휴대폰을 사용하면 나무가 시들어 버려요.`)
};

const pt_br_walkturough_plant_die_title = /** @type {(inputs: Walkturough_Plant_Die_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se usar seu telefone, sua árvore murchará.`)
};

const ru_walkturough_plant_die_title = /** @type {(inputs: Walkturough_Plant_Die_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дерево завянет, если вы будете пользоваться телефоном.`)
};

const th_walkturough_plant_die_title = /** @type {(inputs: Walkturough_Plant_Die_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หากคุณใช้โทรศัพท์ ต้นไม้ของคุณจะเหี่ยวเฉา`)
};

const tr_walkturough_plant_die_title = /** @type {(inputs: Walkturough_Plant_Die_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefonunu kullanırsan ağacınız kurur.`)
};

const zh_cn_walkturough_plant_die_title = /** @type {(inputs: Walkturough_Plant_Die_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注意！如果你中断专注使用手机，树就会枯死`)
};

const zh_tw_walkturough_plant_die_title = /** @type {(inputs: Walkturough_Plant_Die_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注意！如果你中斷專注使用手機，樹就會枯死`)
};

/**
* | output |
* | --- |
* | "If you use your phone, your tree will wither." |
*
* @param {Walkturough_Plant_Die_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const walkturough_plant_die_title = /** @type {((inputs?: Walkturough_Plant_Die_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkturough_Plant_Die_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_walkturough_plant_die_title(inputs)
	if (locale === "ar") return ar_walkturough_plant_die_title(inputs)
	if (locale === "de") return de_walkturough_plant_die_title(inputs)
	if (locale === "es") return es_walkturough_plant_die_title(inputs)
	if (locale === "fr") return fr_walkturough_plant_die_title(inputs)
	if (locale === "it") return it_walkturough_plant_die_title(inputs)
	if (locale === "ja") return ja_walkturough_plant_die_title(inputs)
	if (locale === "ko") return ko_walkturough_plant_die_title(inputs)
	if (locale === "pt_br") return pt_br_walkturough_plant_die_title(inputs)
	if (locale === "ru") return ru_walkturough_plant_die_title(inputs)
	if (locale === "th") return th_walkturough_plant_die_title(inputs)
	if (locale === "tr") return tr_walkturough_plant_die_title(inputs)
	if (locale === "zh_cn") return zh_cn_walkturough_plant_die_title(inputs)
	return zh_tw_walkturough_plant_die_title(inputs)
});